import { createContext, useContext } from 'react';
import { useStore } from 'zustand';
import { useChatDialogStore } from './store';
import type { ChatDialogState } from './types';

/** Выбранное рабочее пространство переписки */
export const ChatDialogWorkspaceContext = createContext<typeof useChatDialogStore | null>(null);

/** Возвращает хранилище выбранного рабочего пространства */
export const useChatDialogWorkspaceApi = () => useContext(ChatDialogWorkspaceContext) ?? useChatDialogStore;

/** Получает состояние выбранной переписки */
export const useChatDialogWorkspace = <T>(selector: (state: ChatDialogState) => T): T => (
    useStore(useChatDialogWorkspaceApi(), selector)
);
